import { apiGet, apiPost, getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { KeycloakUserID } from "userful-chronos-app-common-js/dist/models/usermgt/usermgt";
import usermgtStore from "../usermgtStore";
import { mfaSliceActions, MFAConfig, EmailOtpConfig, OtpConfig } from "../mfaSlice";
import { usermgtSliceActions } from "../usermgtSlice";
import { checkReponseIsValid } from "./levelCallers";

const MFA_ROOT = "/aether/auth/kc/mfa";
const MFA_CONFIG = `${MFA_ROOT}`;
const MFA_OTP_UPDATE = `${MFA_ROOT}/otp/update`;
const MFA_EMAIL_UPDATE = `${MFA_ROOT}/otp/email/update`;
const MFA_RESET_USER_OTP_FLOW = `${MFA_ROOT}/otp/user/enable`;

const getError = (response: any) => {
    return {
        success: false,
        arg: response?.data?.arg ?? "",
        errorCode: response?.data?.errorCode ?? "",
        moduleID: response?.data?.moduleID ?? "",
        severity: response?.data?.severity ?? "",
        msg: response?.data?.unlocalizedMsg ?? "",
    };
};

const catch403Error = (e: any) => {
    if (getGlobalStates().keycloak && e && e.response?.status === 403) {
        console.error("Logged out!");
        window.location.reload();
    } else {
        console.warn("failed", e);
    }
};

const dispatchError = (response: any) => {
    const getErrorMessage = getError(response);
    usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
    usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
    const message = getErrorMessage.msg || "Unable to fetch MFA configuration";
    usermgtStore.dispatch(mfaSliceActions.setMfaError(message));
};

export const getMfaConfigFromServer = (token: string) => {
    const url = getGlobalStates().host + MFA_CONFIG;

    apiGet(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("mfaConfig", response)) {
                dispatchError(response);
                return;
            }
            usermgtStore.dispatch(mfaSliceActions.setMfaLoading(false));
            usermgtStore.dispatch(mfaSliceActions.setMfaConfig(response.data.arg as MFAConfig));
        })
        .catch((err) => {
            usermgtStore.dispatch(mfaSliceActions.setMfaError(err?.message ?? "Unable to fetch MFA configuration"));
            usermgtStore.dispatch(mfaSliceActions.setMfaLoading(false));
            catch403Error(err);
        });
};

export const updateMfaConfigOnServer = async (
    payload: { otpConfig: OtpConfig; emailOtpConfig: EmailOtpConfig },
    token: string,
) => {
    const urlOtp = getGlobalStates().host + MFA_OTP_UPDATE;
    const urlEmail = getGlobalStates().host + MFA_EMAIL_UPDATE;

    const requests: Array<() => Promise<any>> = [];
    if (payload.otpConfig) {
        requests.push(() =>
            apiPost(urlOtp, payload.otpConfig, {
                headers: { Authorization: `Bearer ${token}` },
            }),
        );
    }
    if (payload.emailOtpConfig) {
        requests.push(() =>
            apiPost(urlEmail, payload.emailOtpConfig, {
                headers: { Authorization: `Bearer ${token}` },
            }),
        );
    }

    let latestConfig: MFAConfig | null = null;
    try {
        for (const req of requests) {
            const response = await req();
            if (!checkReponseIsValid("mfaUpdate", response)) {
                dispatchError(response);
                usermgtStore.dispatch(mfaSliceActions.setMfaSaving(false));
                return;
            }
            latestConfig = response.data.arg as MFAConfig;
        }
        if (latestConfig) {
            usermgtStore.dispatch(mfaSliceActions.setMfaConfig(latestConfig));
        }
        usermgtStore.dispatch(mfaSliceActions.setMfaSaving(false));
    } catch (err: any) {
        usermgtStore.dispatch(mfaSliceActions.setMfaSaving(false));
        usermgtStore.dispatch(mfaSliceActions.setMfaError(err?.message ?? "Unable to update MFA configuration"));
        catch403Error(err);
    }
};

export const resetUserOtpFlow = async (payload: KeycloakUserID, token: string) => {
    const url = getGlobalStates().host + MFA_RESET_USER_OTP_FLOW;

    apiPost(url, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("enableUserOtpFlow", response)) {
                dispatchError(response);
                return;
            }
            usermgtStore.dispatch(mfaSliceActions.setMfaLoading(false));
        })
        .catch((err) => {
            usermgtStore.dispatch(mfaSliceActions.setMfaError(err?.message ?? "Unable to enable user otp flow"));
            catch403Error(err);
        });
};
